import { ApiError } from '@nucleus-commerce/api-client/transport';

export type SecurityRefusal = 'not_owner' | 'owner_needs_two_factor' | null;

/** Which of the backend's two known refusals a failed change is, if either. */
export function securityRefusal(error: unknown): SecurityRefusal {
  if (!(error instanceof ApiError)) return null;
  if (error.kind === 'forbidden') return 'not_owner';
  if (error.status === 422 && error.fieldErrors['body.security.requireTwoFactor']) {
    return 'owner_needs_two_factor';
  }
  return null;
}
